import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { FC, useMemo } from "react";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import NavigationSection from "@/components/NavigationSection";
import CheckboxLink from "@/components/CheckboxLink";
import Colors from "@/consts/Colors";

interface Props {
  query: ProductSearchQueryParameter;
  queryController: SearchQueryParameterController<ProductSearchQueryParameter>;
}

const NavigationSectionColor: FC<Props> = ({
  query,
  queryController,
}): JSX.Element => {
  const splitedColors = useMemo<string[]>(() => {
    const value = query.colors;

    return value ? value.split(",") : [];
  }, [query]);

  return (
    <NavigationSection title={`カラー`} defaultOpen={!!query.colors}>
      <ul className="text-sm space-y-4">
        {Colors.map((value) => {
          const checked = splitedColors.includes(value.id.toString());

          return (
            <li key={value.id}>
              <CheckboxLink
                checked={checked}
                href={queryController.toPath({
                  colors: checked
                    ? splitedColors
                        .filter((v) => v !== value.id.toString())
                        .join(",")
                    : [...splitedColors, value.id.toString()].join(","),
                })}
              >
                <div className="flex items-center space-x-8">
                  <div
                    className="w-12 h-12 rounded-full border border-gray-100"
                    style={{ background: value.style }}
                  />
                  <span>{value.name}</span>
                </div>
              </CheckboxLink>
            </li>
          );
        })}
      </ul>
    </NavigationSection>
  );
};
export default NavigationSectionColor;
